@import '../../common/vars.scss';

.new-plan-info-wrap {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  background: white;
  color: $color-text-primary !important;

  box-shadow: 0px 4px 10px 0px rgba(0, 8, 22, 0.08),
    0px 0px 2px 0px rgba(0, 8, 22, 0.16);

  border-radius: 8px;
  border-top-left-radius: 16px;
  box-shadow: none;

  border: none;
  cursor: unset;
  padding: 0;

  &:hover {
    outline: none;
    box-shadow: none;
  }
}

.offer-card-amount-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-text {
  font-family: Graphik;
  font-size: 24px;
  font-weight: 500;
  line-height: 26.4px;
  text-align: left;
}

.change-plan-button {
  padding: 8px 24px;
  border-radius: 8px;
  border: 2px solid $color-upgrade-border;
  cursor: pointer;
  background-color: white;

  span {
    color: $color-upgrade-content;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
  }
}
